<script setup lang="ts">
/**
 * `/chat` 与 `/chat/:id` 的视图（同一条路由，可选参数）。
 *
 * 它只做一件事：把地址里的东西翻译成 `ChatScreen` 的 props。
 * 领域参数优先从 query 取（`/chat?domain=family_education`），
 * 这正是原实现里服务端组件做的事——那一层在 SPA 里没有对应物，
 * 但"从 URL 读取初始领域"这条语义要保留，否则从首页带领域进聊天页会失效。
 */

import { computed } from 'vue';
import { useRoute } from 'vue-router';

import ChatScreen from '../components/chat/ChatScreen.vue';
import { parseDomain } from '../lib/schemas';

const route = useRoute();

const conversationId = computed(() => {
  const raw = route.params.id;
  if (typeof raw === 'string' && raw.length > 0) return raw;
  return undefined;
});

/** 领域来自 query；非法值解析为 undefined，而不是把脏字符串传进控制器。 */
const initialDomain = computed(() => parseDomain(route.query.domain) ?? undefined);
</script>

<template>
  <ChatScreen :conversation-id="conversationId" :initial-domain="initialDomain" />
</template>
